import React from "react";
import { Button, Popconfirm, Tag, Tooltip } from "antd";
import { Pencil, Trash2 } from "lucide-react";
import { IMaster, MasterType } from "../../../types/api/master";

const TYPE_COLOR: Record<MasterType, string> = {
  SUBJECT: "purple",
  STYLE: "blue",
  MEDIUM: "cyan",
  MATERIAL: "geekblue",
  FINISH: "gold",
  METHOD: "volcano",
  BASE: "lime",
  TAGS: "orange",
};

interface GetMasterColumnsParams {
  onEdit: (record: IMaster) => void;
  onDelete: (id: string) => void;
}

export function getMasterColumns({ onEdit, onDelete }: GetMasterColumnsParams) {
  return [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text: string, record: IMaster) => (
        <div>
          <div className="font-medium text-slate-800">{text}</div>
          {record.slug && (
            <div className="text-xs text-slate-400">{record.slug}</div>
          )}
        </div>
      ),
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (t: MasterType) => (
        <Tag color={TYPE_COLOR[t] ?? "default"}>{t}</Tag>
      ),
    },
    {
      title: "Used By",
      dataIndex: "usageCount",
      key: "usageCount",
      width: 110,
      render: (count: number) => (
        <Tooltip title={count ? `Assigned to ${count} live sculpture${count === 1 ? "" : "s"}` : "Not assigned to any sculpture yet"}>
          <span className={count ? "text-slate-700" : "text-slate-400"}>
            {count || 0} {count === 1 ? "sculpture" : "sculptures"}
          </span>
        </Tooltip>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 100,
      render: (status: boolean) => (
        <Tag color={status ? "green" : "red"}>
          {status ? "Active" : "Inactive"}
        </Tag>
      ),
    },
    {
      title: "Action",
      key: "action",
      width: 90,
      render: (_: any, record: IMaster) => (
        <div className="flex gap-1" onClick={(e) => e.stopPropagation()}>
          <Tooltip title="Edit">
            <Button
              size="small"
              icon={<Pencil size={14} />}
              onClick={() => onEdit(record)}
              className="text-slate-500 hover:text-blue-600 border-none shadow-none bg-transparent"
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Popconfirm
              title="Delete this record?"
              onConfirm={() => onDelete(record._id)}
              okText="Delete"
              okType="danger"
              cancelText="Cancel"
            >
              <Button
                size="small"
                icon={<Trash2 size={14} />}
                className="text-slate-500 hover:text-red-600 border-none shadow-none bg-transparent"
              />
            </Popconfirm>
          </Tooltip>
        </div>
      ),
    },
  ];
}
